import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { FertilizerCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface FertilizerCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const FertilizerCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: FertilizerCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="fertilizer"
      onSaveSuccess={onSaveSuccess}
    >
      <FertilizerCellDisplay value={value} />
    </TraitCellContainer>
  )
}
